import { $handleError, $updateArr, $updateOrAdd,$deleteFromArray } from '@/utils';
import userService from '@User/service/user.service';
import Vue from 'vue';
export const USER = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    updateLoading: false,
    options: {},
    typeHeadEntries: []
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },
    GET_OPTIONS(state) {
      return state.options;
    },
    GET_TYPEHEAD_ENTRIES(state) {
      return state.typeHeadEntries;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },
    SET_OPTIONS(state, value) {
      state.options = value;
    },
    SET_TYPEHEAD_ENTRIES(state, value) {
      state.typeHeadEntries = value;
    },
  },
  actions: {
    GET_USERS({ commit }) {
      commit('SET_LOADING', true);
      userService
        .get({
          pageNumber: 1,
          pageSize: 1000,
          sortColumn: 'name',
          sortDirection: 'asc',
        })
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        });
    },
    GET({ commit, state }) {
      commit('SET_LOADING', true);
      userService
        .get(state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
    GET_BY_PARAMS({ commit }, params) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true);
        userService
          .get(params)
          .then((res) => {
            resolve(res.data.items);
          })
          .catch((err) => {
            $handleError(err);
            reject(err);
          })
          .finally(() => {
            commit('SET_LOADING', false);
          });
      });
    },
    GET_MANAGEMENT({ commit, state }) {
      commit('SET_LOADING', true);
      userService
        .getManagement(state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
    GET_BY_ID(context, id) {
      return userService.getById(id).catch((err) => {
        $handleError(err);
      });
    },
    UPDATE({ dispatch, state, commit }, data) {
      commit('SET_UPDATE_LOADING', true);
      return userService
        .update(data)
        .then((res) => {
          
          var message = 'User updated successfully!';
          if (data.id) {
            $updateArr(state.entries, res.data);
            
          } else {
            message = 'User added successfully!';
            dispatch('USER_INVITATION/GET', {}, { root: true });
          }
          Vue.prototype.$dialog.notify.success(message, {
            position: 'top-right',
            timeout: 3000,
          });

        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_UPDATE_LOADING', false);
        });
    },
    SUSPEND({ state }, { id, status }) {
      return userService
        .suspend(id, status)
        .then((res) => {
          $updateOrAdd(state.entries, res.data);
          Vue.prototype.$dialog.notify.success(
            `User ${status ? 'Suspended' : 'Reactivated'} Successfully`,
            {
              position: 'top-right',
              timeout: 3000,
            },
          );
        })
        .catch((err) => {
          $handleError(err);
        });
    },
    DELETE({ state, commit }, id) {
      return userService
        .delete(id)
        .then(() => {
          $deleteFromArray(state.entries, id);
          commit('SET_TOTAL', --state.total);
          Vue.prototype.$dialog.notify.success(
            `User Deleted Successfully`,
            {
              position: 'top-right',
              timeout: 3000,
            },
          );
        })
        .catch((err) => {
          $handleError(err);
        });
    },
    GET_TYPEHEAD({ commit }) {
      commit('SET_LOADING', true);
      userService
        .typeHead()
        .then((res) => {
          commit('SET_TYPEHEAD_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
  },
};
